import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";

export const NotificationService = {
  getPreventiveActionsByDateAndId,
  preventiveActionNotification,
  cityWisePreventiveActionNotification,
  distinctPreventiveActionNotification,
  countPreventiveNotification,
  getPreventiveActionsNotSendNotification,
  cityWisePreventiveActionNotificationCount,
  distinctPreventiveActionNotificationCount,
  getPreventiveActionsNotSendNotificationCount,
  getPreventiveActionsNotSendNotificationDistictWise,
  updateInformation,
  districtWiseCountPreventiveNotification,
};
const baseUrl = config.apiGateway.baseUrl;
function getPreventiveActionsByDateAndId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/getPreventiveActionsByDateAndId/`,
    requestOptions
  );
}
function preventiveActionNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/preventiveActionNotification/`,
    requestOptions
  );
}
function cityWisePreventiveActionNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/cityWisePreventiveActionNotification/`,
    requestOptions
  );
}
function distinctPreventiveActionNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/distinctPreventiveActionNotification/`,
    requestOptions
  );
}
function countPreventiveNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/countPreventiveNotification/`,
    requestOptions
  );
}
function getPreventiveActionsNotSendNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/getPreventiveActionsNotSendNotification/`,
    requestOptions
  );
}
function cityWisePreventiveActionNotificationCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/cityWisePreventiveActionNotificationCount/`,
    requestOptions
  );
}

function distinctPreventiveActionNotificationCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/distinctPreventiveActionNotificationCount/`,
    requestOptions
  );
}
function getPreventiveActionsNotSendNotificationCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/getPreventiveActionsNotSendNotificationCount/`,
    requestOptions
  );
}
function getPreventiveActionsNotSendNotificationDistictWise(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/getPreventiveActionsNotSendNotificationDistictWise/`,
    requestOptions
  );
}
function updateInformation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/notification/update`, requestOptions);
}
function districtWiseCountPreventiveNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/notification/districtWiseCountPreventiveNotification/`,
    requestOptions
  );
}